export default __webpack_public_path__ + "static/media/everycred-full-logo.b7aa90e8.svg";